import { render, staticRenderFns } from "./ModalViewTipoUbicacion.vue?vue&type=template&id=1d21ec10&scoped=true&"
import script from "./ModalViewTipoUbicacion.vue?vue&type=script&lang=ts&"
export * from "./ModalViewTipoUbicacion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewTipoUbicacion.vue?vue&type=style&index=0&id=1d21ec10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21ec10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1d21ec10', component.options)
    } else {
      api.reload('1d21ec10', component.options)
    }
    module.hot.accept("./ModalViewTipoUbicacion.vue?vue&type=template&id=1d21ec10&scoped=true&", function () {
      api.rerender('1d21ec10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTipoUbicacion/ModalViewTipoUbicacion.vue"
export default component.exports